import { gql } from 'apollo-boost';

export const getPagePostsQuery = gql`
  query Products($skip: Int!, $take: Int!, $category: ID) {
    Posts(input: { category: $category, skip: $skip, take: $take }) {
      totalCount
      items {
        id
        title
        description
        createDate
        images {
          id
          url
          thumbnailUrl
        }
        token
        shortLinkUrl
        totalHit
        totalView
        isVisible
        category {
          id
          title
        }
        links {
          id
          title
          url
          createDate
          logoName
          token
          shortLinkUrl
          totalHit
          isVisible
        }
      }
    }
  }
`;

export const getPagePreviewPostsQuery = gql`
  query PostsPreview(
    $skip: Int!
    $take: Int!
    $category: ID
    $pageName: String!
  ) {
    PostsPreview(
      input: { category: $category, skip: $skip, take: $take, pageName: $pageName }
    ) {
      id
      title
      description
      shortLink
      shortLinkUrl
      images {
        id
        url
        thumbnailUrl
      }
      category {
        id
        title
      }
    }
  }
`;

export const newPostQuery = gql`
  mutation NewPost(
    $title: String!
    $description: String
    $images: [ID!]!
    $shortLink: String!
    $category: ID!
    $links: [NewInnerLinkInput!]
  ) {
    NewPost(
      input: {
        title: $title
        description: $description
        images: $images
        shortLink: $shortLink
        category: $category
        links: $links
      }
    ) {
      id
      title
      description
      createDate
      images {
        id
        url
        thumbnailUrl
      }
      shortLinkUrl
      totalHit
      totalView
      isVisible
      category {
        id
        title
      }
      links {
        id
        title
        url
        createDate
        logoName
        token
        shortLinkUrl
        totalHit
        isVisible
      }
    }
  }
`;

export const editPostQuery = gql`
  mutation EditPost(
    $id: ID!
    $title: String!
    $description: String
    $images: [ID!]!
    $shortLink: String!
    $category: ID!
    $links: [NewInnerLinkInput!]
  ) {
    EditPost(
      input: {
        id: $id
        title: $title
        description: $description
        images: $images
        shortLink: $shortLink
        category: $category
        links: $links
      }
    ) {
      id
      title
      description
      createDate
      images {
        id
        url
        thumbnailUrl
      }
      shortLinkUrl
      totalHit
      totalView
      isVisible
      category {
        id
        title
      }
      links {
        id
        title
        url
        createDate
        logoName
        token
        shortLinkUrl
        totalHit
        isVisible
      }
    }
  }
`;
